export const SERVERS_HOST_LIST = ['https://beta.lfs.rest/api/','https://beta.lfs.rest/api/']
export const COUNTRIES_SNG = ["AB","KG","TM","AM","MD","UZ","BY","RU","UA","KZ","TJ","AZ" ]
export const LANG_DEFAULT = 'ru'
export const RECAPTCHA_KEY = '6LdKje4mAAAAAFTrVXhVqo8uF989Ib-hollmPCHx'

